/** apiErrorMessage reads the message of an API validation or conflict body, else the fallback. */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const e = error as { fields?: { message?: string }[]; title?: string } | null
  return e?.fields?.[0]?.message ?? e?.title ?? fallback
}
